import { readApiErrorCode } from './api-error';

// Server refusals tied to a category's Matter rule (XPEN-3655):
// - matter_not_allowed_for_category: a save pairs an expense with a Matter its
//   category does not allow (XPEN-3761);
// - imputation_matter_restriction_invalid: a category rule names Matters that do
//   not exist, listed in invalid_matter_numbers (XPEN-3757).

export const matterRuleSaveErrorKey = (error, fallbackKey) =>
    readApiErrorCode(error) === 'matter_not_allowed_for_category'
        ? 'error_matter_not_allowed_for_category'
        : fallbackKey;

export const imputationMatterRuleErrorMessage = (t, error, fallbackMessage) => {
    if (readApiErrorCode(error) !== 'imputation_matter_restriction_invalid') {
        return fallbackMessage;
    }
    const listed = error?.response?.data?.invalid_matter_numbers;
    // Only plain values are listed: an object would print as "[object Object]",
    // or make join() throw and the refusal show no message at all.
    const numbers = Array.isArray(listed)
        ? listed.filter((n) => typeof n === 'string' || typeof n === 'number').map(String)
        : [];
    if (!numbers.length) {
        return t.read('error_imputation_matter_restriction_invalid');
    }
    // A function, so a "$" in a typed number is not read as a replacement pattern.
    return t.read('error_imputation_matter_restriction_unknown_numbers').replace('{numbers}', () => numbers.join(', '));
};
